import { render, staticRenderFns } from "./AnnouncementDetail.vue?vue&type=template&id=5844804e"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports